import Icon from "@ui-kit/icons/Icon.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import Modal from "@ui-kit/overlays/Modal/Modal.web";
import Text from "@ui-kit/typography/Text/Text.web";
import { useDisclosure } from "@shared/hooks/useDisclosure";
import { useTranslation } from "@shared/utils/internationalization";
import { EventPasswordModalProps } from "./EventPasswordModal.props";
import EventPasswordEntryForm from "../EventPasswordEntry/EventPasswordEntry.web";

export interface EventPasswordModalContentProps {
  eventName: string;
  eventSlug: string;
  eventId: number;
  passwordMessage?: string;
  onAuthorizeSuccess: (tickets: Array<number>) => void;
}

export const EventPasswordModalContent = ({
  eventName,
  eventSlug,
  eventId,
  passwordMessage,
  onAuthorizeSuccess,
}: EventPasswordModalContentProps) => {
  const { t } = useTranslation("common");

  return (
    <>
      <Flex
        textAlign="center"
        width="100%"
        alignItems="center"
        direction="column"
        p="0 16px 0 16px"
        borderRadius="20px"
        height="auto"
        data-testid="event-password-modal-content"
      >
        <Icon.Lock.Solid boxSize="120px" mb="2xl" colorPalette="primary" />
        <Text
          fontSize="sm"
          fontWeight="bold"
          color="gray.600"
          mb="xs"
          data-testid="event-password-modal-title-event-name"
        >
          {eventName}
        </Text>
        <Text
          fontSize={{ base: "md", sm: "3xl" }}
          mb="xl"
          pb="xl"
          borderBottomWidth="1px"
          borderBottomColor="gray.400"
        >
          {t("This event is password-protected")}
        </Text>
      </Flex>
      <EventPasswordEntryForm
        eventSlug={eventSlug}
        eventId={eventId}
        onSuccess={onAuthorizeSuccess}
        passwordMessage={passwordMessage}
      />
    </>
  );
};

const EventPasswordModal = ({
  showPasswordAuth,
  onAuthorize,
  eventSlug,
  eventId,
  eventName,
  passwordMessage,
  onCloseModal,
}: EventPasswordModalProps) => {
  const { onClose } = useDisclosure();

  return (
    <Modal
      isCentered
      closeOnEsc={false}
      closeOnOverlayClick={false}
      scrollBehavior="inside"
      size="md"
      isOpen={showPasswordAuth}
      onClose={onClose}
    >
      <Modal.Overlay backgroundColor="secondary.600" />
      <Modal.Body>
        {/* On seating modal in box-office, closes the seating modal, and consequently closes this modal. */}
        {onCloseModal && (
          <Modal.CloseButton color="font.dark" onClick={onCloseModal} />
        )}
        <EventPasswordModalContent
          eventName={eventName}
          eventSlug={eventSlug}
          eventId={eventId}
          passwordMessage={passwordMessage}
          onAuthorizeSuccess={(tickets: Array<number>) => {
            onAuthorize(tickets);
            onClose();
          }}
        />
      </Modal.Body>
    </Modal>
  );
};

export default EventPasswordModal;
